import { teacherRankRoutesObj } from "./path";

import type { IRouteMetadataObj } from "@routes/types";
import { createRoute } from "@/routes/utils";
import { IRoleEnum } from "@/interfaces";

const permission = [IRoleEnum.SUPER_ADMIN];

const teacherRankRouteMetadata: IRouteMetadataObj<typeof teacherRankRoutesObj> =
  {
    list: {
      title: "teacherRank.index.title",
      description: "teacherRank.index.description",
      lazy: () => import("@/pages/teacherRank/table/page"),
      mode: "index",
      type: "main",
      icon: "MedalLine",
      breadcrumbs: [],
      permission,
    },
  };

export const teacherRankRoutes = createRoute<typeof teacherRankRoutesObj>(
  teacherRankRoutesObj,
  teacherRankRouteMetadata,
);
